import type { TranslationKey, TranslationValue } from "./en.ts";

export const zhCN = {
  "common.close": "关闭",
  "common.cancel": "取消",
  "common.back": "上一步",
  "common.next": "下一步",
  "common.choose": "选择",
  "common.save": "保存",
  "common.clear": "清空",
  "common.delete": "删除",
  "common.view": "查看",
  "common.start": "启动",
  "common.stop": "停止",
  "common.restart": "重启",
  "common.more": "更多",
  "common.later": "稍后",
  "common.gotIt": "知道了",
  "common.loading": "正在读取…",
  "common.loadMore": "继续读取",
  "common.optional": "可选",
  "common.user": "用户",
  "common.all": "全部",
  "common.selectAll": "全部选择",
  "common.clearAll": "取消全选",
  "common.copied": "已复制",
  "common.copyCommand": "复制命令",
  "common.unknownTime": "时间未知",
  "common.noWorkspace": "未设置工作目录",
  "common.providerRequired": "请先配置并启用 Provider",
  "common.providersLoading": "正在连接电脑…",
  "common.historyReadOnly": "历史仅供查看",
  "common.provider": "Provider",
  "common.agent": "Agent",
  "common.apiKey": "API Key",
  "common.enter": "回车",
  "error.offline": "本地服务当前离线。",
  "error.notFound": "这项内容已不存在。",
  "error.conflict": "信息已在其他位置发生变化，请刷新后重试。",
  "error.permissionDenied": "当前没有执行这项操作的权限。",
  "error.unauthenticated": "云端登录已失效，请重新登录。",
  "error.invalidArgument": "部分信息不正确，请检查后重试。",
  "error.timeout": "本地服务响应超时，请重试。",
  "error.unavailable": "服务暂时不可用，请稍后重试。",
  "error.unsupported": "这里暂不支持这项操作。",
  "nav.home": "首页",
  "nav.sessions": "会话",
  "nav.work": "任务",
  "nav.notes": "灵感与日记",
  "nav.api": "API 管理",
  "nav.notifications": "通知",
  "nav.help": "帮助",
  "nav.settings": "设置",
  "nav.agents": "Agent 管理",
  "nav.skills": "Skills",
  "skills.title": "Skill 库",
  "skills.lead": "浏览整理后的 Skill，以及来源页面明确记录的命令。",
  "skills.featured": "精选",
  "skills.categories": "按分类浏览",
  "skills.search": "搜索 Skill",
  "skills.all": "全部 Skill",
  "skills.empty": "暂时没有可用 Skill。",
  "skills.unavailable": "本地 Skill 目录暂时不可用。",
  "skills.loading": "正在加载 Skill 库…",
  "skills.open": "打开 Skill",
  "skills.source": "查看来源",
  "skills.version": "最新版本",
  "skills.copy": "复制安装命令",
  "skills.newSessionInstall": "新建会话安装",
  "skills.newSessionUnavailable": "请新建会话来使用这条命令。",
  "skills.count": ({ count }) => `${count} 个 Skill`,
  "skills.noCommand": "来源页面没有识别到安装命令。",
  "skills.commandTitle": "来源页面中的命令",
  "skills.commandBody": "复制来源页面明确记录的命令，或将它作为新会话的首条消息。",
  "nav.language": "语言",
  "nav.themeDark": "切换到深色模式",
  "nav.themeLight": "切换到浅色模式",
  "sync.current": "已同步",
  "sync.pending": "同步中",
  "sync.error": "同步异常",
  "sync.offline": "已离线",
  "sync.loading": "正在检查同步",
  "sync.title": "数据同步",
  "sync.refresh": "刷新同步状态",
  "sync.pendingDetail": ({ count }) => `${count} 项内容等待同步`,
  "sync.failedDetail": ({ count }) => `${count} 项同步失败，需要处理`,
  "language.system": "跟随系统语言",
  "language.systemShort": "跟随系统",
  "language.title": "界面语言",
  "language.description": "选择 OrniWork 的界面语言。项目内容和会话原文不会被翻译。",
  "language.current": "当前语言",
  "status.starting": "启动中",
  "status.running": "进行中",
  "status.waiting": "待处理",
  "status.stopping": "停止中",
  "status.stopped": "已停止",
  "status.completed": "已完成",
  "status.error": "异常",
  "status.exited": "已退出",
  "status.idle": "空闲",
  "status.blocked": "阻塞",
  "status.planned": "计划中",
  "recovery.interruptionTitle": "发现异常中断的会话",
  "recovery.lead": ({ count }) => `Orni 停止时仍有 ${count} 个会话处于打开状态，请确认是否继续。`,
  "recovery.noteTitle": "恢复进程和继续工作是两件事",
  "recovery.noteDetail": "“继续”会在 Provider 就绪后发送内部恢复指令，不会伪装成你的输入，也不会要求重复已经完成的工作。",
  "recovery.group.interrupted_work": "可能有工作尚未完成",
  "recovery.group.uncertain": "需要确认",
  "recovery.group.idle": "当时已打开，但未发现未完成工作",
  "recovery.evidence.managed_run_waiting": "工作当时正在等待输入、确认或外部依赖。",
  "recovery.evidence.managed_run_active": "进程停止时，有工作轮次正在执行。",
  "recovery.evidence.tool_started_without_completion": "有工具调用已经开始，但没有完成记录。",
  "recovery.evidence.turn_started_without_completion": "Provider 最后一轮处理没有完成记录。",
  "recovery.evidence.user_message_not_started": "已经发送的请求还没有开始处理。",
  "recovery.evidence.last_turn_completed": "中断前最近一轮 Provider 处理已经完成。",
  "recovery.evidence.provider_ready_without_work": "Provider 已经就绪，但没有记录到正在进行的工作。",
  "recovery.evidence.insufficient_provider_events": "结构化活动信息不足，无法可靠判断当时状态。",
  "recovery.evidence.interrupted_work": "最近活动表明工作可能被中断。",
  "recovery.evidence.uncertain": "无法可靠判断最后的活动状态。",
  "recovery.evidence.idle": "没有发现未完成的 Provider 工作。",
  "recovery.openSession": "打开会话",
  "recovery.dismissAll": "全部忽略",
  "recovery.restoreOnly": "只恢复会话",
  "recovery.continueSelected": ({ count }) => `继续已选工作（${count}）`,
  "recovery.error": "恢复操作没有完成。",
  "profile.native": "独立会话",
  "profile.orni": "Orni Work",
  "app.documentTitle": "OrniWork · Agent 工作台",
  "app.connecting": "正在连接本地服务…",
  "app.palette.aria": "命令面板",
  "app.palette.placeholder": "搜索功能或会话…",
  "app.palette.empty": "没有匹配的内容",
  "app.palette.hint": "使用快捷键快速跳转；会话和工作资料从各自列表进入。",
  "app.product.mobileAria": "下载 Orni 移动端",
  "app.product.signInAria": "登录 Orni",
  "app.product.mobileTitle": "随时查看你的 Agent",
  "app.product.signInTitle": "登录 Orni",
  "app.product.mobileLead": "安全连接这台电脑上正在运行的会话。",
  "app.product.signInLead": "登录后可使用移动端、远程控制和跨设备同步。",
  "app.product.mobileQrTitle": "扫描二维码获取移动端",
  "app.product.mobilePending": "移动端正在准备发布，本机会话不受影响。",
  "app.product.accountTitle": "使用 Orni 账户登录",
  "app.product.accountPending": "账户服务接入后，可在这里安全登录。",
  "app.product.localWithoutSignIn": "无需登录也可以继续使用本机会话。",
  "app.auth.method": "登录方式",
  "app.auth.emailCode": "邮箱验证码",
  "app.auth.password": "密码",
  "app.auth.forgotPassword": "忘记密码？",
  "app.auth.resetPassword": "重置密码",
  "app.auth.backToSignIn": "返回登录",
  "app.auth.newPassword": "新密码",
  "app.auth.confirmPassword": "确认密码",
  "app.auth.confirmPasswordPlaceholder": "再次输入密码",
  "app.auth.passwordMismatch": "两次输入的密码不一致。",
  "app.auth.email": "邮箱",
  "app.auth.emailPlaceholder": "you@example.com",
  "app.auth.passwordPlaceholder": "至少 10 个字符",
  "app.auth.verificationCode": "验证码",
  "app.auth.codePlaceholder": "6 位数字",
  "app.auth.codeSent": "验证码已发送到你的邮箱。",
  "app.auth.codeResent": "新的验证码已发送。",
  "app.auth.codeVerified": "验证码正确，请设置新密码。",
  "app.auth.resendCode": "重新发送验证码",
  "app.auth.resendIn": ({ seconds }) => `${seconds} 秒后可重新发送`,
  "app.auth.sendCode": "发送验证码",
  "app.auth.verifyAndSignIn": "验证并登录",
  "app.auth.verifyCode": "验证验证码",
  "app.auth.passwordSignIn": "登录",
  "app.auth.sendResetCode": "发送重置验证码",
  "app.auth.resetAndSignIn": "重置密码并登录",
  "app.auth.signingIn": "正在登录",
  "app.auth.unavailable": "账户服务暂时不可用。",
  "app.auth.notConfigured": "当前版本还没有配置 Orni Cloud 地址。",
  "app.auth.signedIn": "Orni 登录成功。",
  "app.auth.signedInTitle": "已登录 Orni",
  "app.auth.signedInDetail": "现在可以在设备之间同步工作内容。",
  "app.auth.signOut": "退出登录",
  "app.account.title": "账户安全",
  "app.account.lead": "验证邮箱后设置新的登录密码。",
  "app.account.codeDetail": "验证码会发送到当前账户绑定的邮箱。",
  "app.account.sendCode": "发送验证码",
  "app.account.verifyCode": "验证验证码",
  "app.account.codeVerified": "邮箱验证成功，请设置新密码。",
  "app.account.verifyFirst": "请先验证邮箱，再设置新密码。",
  "app.account.currentPassword": "当前密码",
  "app.account.currentPasswordPlaceholder": "如果还没设置过密码，可留空",
  "app.account.currentPasswordDetail": "已有密码时必须填写当前密码。",
  "app.account.newPassword": "新密码",
  "app.account.confirmPassword": "确认密码",
  "app.account.passwordMismatch": "两次输入的密码不一致。",
  "app.account.passwordUpdated": "密码已更新。",
  "app.account.updatePassword": "更新密码",
  "app.account.updateFailed": "密码更新失败。",
  "app.auth.browserSignIn": "在浏览器中继续登录",
  "app.auth.browserSignInDetail": "支持邮箱、Google、GitHub 和已绑定账户",
  "app.auth.orSignInHere": "或在这里登录",
  "app.auth.callbackWorking": "正在完成登录……",
  "app.auth.callbackSuccess": "登录成功",
  "app.auth.callbackError": "登录未能完成",
  "app.auth.callbackClose": "可以关闭此窗口并返回 Orni。",
  "app.recent.title": "最近会话",
  "app.recent.viewAll": "查看全部",
  "app.recent.empty": "还没有会话",
  "dialog.commandHint": "复制后在本机终端执行。Orni 不会在后台替你安装或执行命令。",
  "home.quickAccess": "快捷入口",
  "home.setup": "配置向导",
  "home.mobile": "移动端",
  "home.signIn": "登录",
  "home.kicker": "让 Agent 的工作清晰可控",
  "home.headline.0": "会话异常中断？开启异常自动恢复",
  "home.headline.1": "在手机端也可以开启会话",
  "home.headline.2": "为每个会话构建独一无二的工作台",
  "home.headline.3": "管理全部 Codex / Claude Code / OpenCode 会话",
  "home.headline.4": "让执行过程、项目文档都变得清晰可控",
  "home.headline.5": "不再被 AI 输出的数万行信息淹没",
  "home.placeholder": "直接输入你想完成的事情…",
  "home.providerRequired": "请先配置并启用一个 Provider",
  "home.workMode": "工作方式",
  "home.creating": "正在创建",
  "home.start": "开始",
  "home.connecting": ({ provider }) => `正在创建会话并连接 ${provider}…`,
  "home.inputTooLong": ({ limit }) => `输入内容超过 ${limit}，请先发送核心内容，较长资料可在进入会话后继续发送。`,
  "home.createFailed": "会话未创建，请重试。",
  "home.capability.title": "把每个 Agent 工作流都掌握在手中",
  "home.capability.lead": "原生终端、简约会话和工作台组成一个完整系统：工作持续运行、信息始终同步、每次变化都有依据。",
  "home.capability.agents.title": "所有 Agent，一处管理",
  "home.capability.agents.detail": "同时使用 Codex、Claude Code 和 OpenCode，并保留各自完整的原生终端。",
  "home.capability.hosting.title": "工作持续运行",
  "home.capability.hosting.detail": "离开页面也不会打断工作；异常会被记录，并按你的设置自动恢复。",
  "home.capability.context.title": "一份可靠事实",
  "home.capability.context.detail": "目标、需求、文档、轮次和进展持续更新，并约束每个 Agent 的执行。",
  "home.capability.trace.title": "每次变化可追踪",
  "home.capability.trace.detail": "问题、决策、分工、结果和文档变化始终保持关联。",
  "sessions.title": "会话",
  "sessions.lead": "Native 与 Orni Work 的所有受控会话。",
  "sessions.filter.running": "进行中",
  "sessions.filter.waiting": "待处理",
  "sessions.filter.completed": "已完成",
  "sessions.search": "搜索会话…",
  "sessions.searchPlaceholder": "搜索会话…",
  "sessions.newSession": "新建会话",
  "sessions.importSession": "导入会话",
  "sessions.switchSession": "切换会话",
  "sessions.emptyTitle": "还没有会话",
  "sessions.emptyDetail": "新建或导入一个会话后开始工作。",
  "sessions.noMatches": "没有匹配的会话",
  "sessions.noMatchesDetail": "换一个搜索词试试。",
  "sessions.selectTitle": "选择一个会话",
  "sessions.selectDetail": "从左侧列表选择会话打开终端。",
  "initialization.title": "完成电脑初始化",
  "initialization.detail": "配置 Agent、电脑名称和 OrniWork 项目目录。",
  "initialization.openSettings": "打开初始化设置",
  "initialization.finish": "开始使用 OrniWork",
  "initialization.previewTitle": "预览模式",
  "initialization.previewDetail": "当前初始化页面只使用内存状态，修改操作已禁用，不会改变真实电脑数据。",
  "sessions.deleteSession": "删除会话",
  "sessions.deleteConfirm": ({ title }) => `确定删除“${title}”？会话历史也会被删除。`,
  "sessions.column.session": "会话",
  "sessions.column.status": "状态",
  "sessions.column.progress": "进度",
  "sessions.column.updated": "更新时间",
  "sessions.runCount": ({ count }) => `${count} 个运行段`,
  "sessions.deletePrompt": "确定删除？",
  "sessions.stopTitle": "停止会话？",
  "sessions.restartTitle": "重启会话？",
  "sessions.stopDetail": "当前 Provider 进程会停止，历史不会删除。",
  "sessions.restartDetail": "当前 Provider 进程会重启，正在执行的操作可能被中断。",
  "sessions.stopAction": "停止会话",
  "sessions.restartAction": "重启会话",
  "sessions.stopAll": "停止全部",
  "sessions.stopAllTitle": "停止全部会话？",
  "sessions.stopAllDetail": "所有仍在运行的主控和 Worker Provider 进程都会停止；会话历史和工作台资料会保留。",
  "sessions.stopAllAction": "停止全部会话",
  "sessions.computer": "电脑",
  "sessions.chooseComputer": "选择电脑",
  "sessions.computerTargetHint": "新会话将在这台电脑运行，会话列表仍显示全部电脑。",
  "sessions.computerUnavailable": "暂时没有返回已连接的电脑，请稍后重试。",
  "sessions.computerScope": "电脑作用域操作使用这台电脑",
  "sessions.fleetScope": "会话列表仍显示所有电脑",
  "sessions.allComputers": "全部电脑",
  "notifications.title": "通知",
  "notifications.lead": "需要你确认、审核或关注的事项都会集中在这里。",
  "notifications.pending": "待处理",
  "notifications.emptyTitle": "没有新的通知",
  "notifications.emptyDetail": "需要你处理的事项会出现在这里。",
  "work.title": "任务",
  "work.workspaceTitle": "工作台",
  "work.lead": "跨所有会话汇总目标、计划、Todo、进度和待确认事项。",
  "work.redesignDetail": "Orni Work 工作台正在重新设计。原生会话仍可在会话列表中使用。",
  "work.redesignStatus": "工作台数据暂时停用",
  "work.filter.all": "全部工作",
  "work.filter.confirm": "待你确认",
  "work.filter.running": "进行中",
  "work.filter.blocked": "阻塞",
  "work.filter.planned": "计划中",
  "work.filter.completed": "已完成",
  "work.filter.status": "状态",
  "work.filter.sessionType": "会话关系",
  "work.filter.allSessions": "全部会话",
  "work.empty.pending": "当前范围没有待处理事项",
  "work.section.completed": "已完成的工作",
  "work.section.planned": "计划中的工作",
  "work.section.active": "进行中的会话",
  "work.empty.sessions": "当前范围没有匹配的会话",
  "work.section.todos": "计划与 Todo",
  "work.approve": "批准",
  "work.reject": "拒绝",
  "work.openSession": "打开会话",
  "createMenu.newSession": "新建会话",
  "createMenu.nativeOnlyHint": "OpenCode 当前仅支持 Native 会话",
  "createMenu.nativeOnly": "仅 Native",
  "createMenu.import": "导入已有项目",
  "create.mode.nativeDetail": "完整保留原生 CLI 终端与交互",
  "create.mode.orniDetail": "按需维护目标、计划、上下文和进度",
  "create.permission.readOnly": "只读",
  "create.permission.readOnlyDetail": "只查看和分析，不修改文件",
  "create.permission.workspaceWrite": "工作区可写",
  "create.permission.workspaceWriteDetail": "可修改当前工作区",
  "create.permission.fullAccess": "完全访问",
  "create.permission.fullAccessDetail": "允许执行文件和命令操作",
  "create.unknownWorkspace": "未识别目录",
  "create.importedProject": "导入的项目",
  "create.title.native": ({ provider }) => `新建 ${provider} 原生会话`,
  "create.title.orni": ({ provider }) => `新建 ${provider} Orni Work 会话`,
  "create.nativeLead": "启动一个新的原生 Agent 会话",
  "create.historyError": "没有读取到历史会话，请检查项目目录。",
  "create.historyDiscoverError": "无法读取所选 CLI 的会话记录。",
  "create.import.title": "导入已有项目",
  "create.import.sessionsTitle": "导入 CLI 会话",
  "create.import.sessionsLead": "选择 Codex、Claude Code 或 OpenCode，再选择其中已有的会话。",
  "create.import.sourcesTitle": "选择要导入的已有信息",
  "create.import.detailsLead": "选择项目目录和使用的 AI，下一步选择希望参考的内容。",
  "create.import.sourcesLead": "选择希望 OrniWork 参考的历史会话和项目内容。",
  "create.projectName": "项目名称",
  "create.projectNameAuto": "选择目录后会自动填写",
  "create.sessionName": "会话名称",
  "create.sessionNamePlaceholder": "会话名称，例如：支付模块重构",
  "create.initialInstruction": "首条输入",
  "create.initialInstructionPlaceholder": "可选：新建会话后从这条输入开始",
  "create.sessionType": "会话类型",
  "create.projectDirectory": "项目目录",
  "create.projectDirectoryAria": "需要导入的项目目录",
  "create.chooseDirectory": "选择目录",
  "create.advanced": "高级设置",
  "create.autoGenerated": "自动生成",
  "create.workspace": "工作目录",
  "create.provider": "Provider",
  "create.workspacePlaceholder": "自动生成，也可输入或选择目录",
  "create.workspaceAria": "工作目录，留空时自动生成",
  "create.chooseWorkspace": "选择工作目录",
  "create.permissions": "权限",
  "create.scope.aria": "项目信息范围",
  "create.scope.documents": "文档",
  "create.scope.documentsDetail": "需求、说明与规范",
  "create.scope.code": "代码",
  "create.scope.codeDetail": "实现、配置与测试",
  "create.scope.gitDetail": "状态、提交与历史",
  "create.scope.other": "其他",
  "create.scope.otherDetail": "其他相关项目内容",
  "create.history.title": "历史会话",
  "create.history.filter": "导入状态筛选",
  "create.history.notImported": "仅未导入",
  "create.history.imported": "已导入",
  "create.history.noImported": "还没有已导入的会话",
  "create.history.refresh": "刷新 CLI 会话",
  "create.history.selected": ({ selected, total }) => `已选择 ${selected} / ${total}`,
  "create.history.emptyTitle": "没有找到匹配的历史会话",
  "create.history.emptyDetail": "仍可从所选文档、代码和 Git 内容开始了解项目。",
  "create.history.close": "关闭历史",
  "create.history.emptyMessages": "没有可显示的历史消息",
  "create.history.loading": "正在查找历史会话…",
  "create.history.sessionCount": ({ count }) => `${count} 个会话`,
  "create.history.deselect": "取消选择会话",
  "create.history.select": "选择会话",
  "create.history.noPreview": "没有可显示的用户消息",
  "create.history.messageCount": ({ count }) => `${count} 条消息`,
  "create.creating": "正在创建…",
  "create.importAndOpen": "导入并打开",
  "create.createAndOpen": "创建并打开",
  "platform.update.aria": "OrniWork 更新",
  "platform.update.required": "需要更新",
  "platform.update.available": "发现新版本",
  "platform.update.fallback": "更新后可继续使用最新的 Provider 和会话管理能力。",
  "platform.update.action": "前往更新",
  "platform.announcement.aria": "启动公告",
  "platform.announcement.label": "OrniWork 公告",
  "platform.announcement.details": "查看详情",
  "settings.title": "设置",
  "settings.lead": "管理 Provider、项目目录和本地运行环境。",
  "agents.title": "Agent 管理",
  "agents.lead": "管理这台电脑上的 Agent CLI，并导入已有会话。",
  "agents.providers.title": "已安装的 Agent",
  "agents.providers.lead": "启用、配置并查看新会话使用的 Agent CLI。",
  "agents.providers.candidate": "候选适配器 · 仅供发现",
  "agents.providers.candidateStatus": "尚未开放运行",
  "agents.history.open": "导入历史会话",
  "settings.agents.title": "Agent 管理",
  "settings.agents.lead": "Agent CLI 已移到独立的管理菜单。",
  "settings.agents.actionTitle": "管理已安装的 Agent",
  "settings.agents.actionDetail": "在一个页面启用工具、配置路径并导入原生会话。",
  "settings.agents.open": "打开 Agent 管理",
  "settings.transport.title": "会话连接方式",
  "settings.transport.lead": "选择 Desktop 将会话指令发送到哪里。",
  "settings.transport.local.title": "当前电脑",
  "settings.transport.local.detail": "通过本机 Daemon 直接创建和控制会话。",
  "settings.transport.local.action": "本机",
  "settings.transport.remote.title": "远程电脑",
  "settings.transport.remote.detail": "通过 Orni Cloud 在其他已登录电脑上创建和控制会话。",
  "settings.transport.remote.action": "远程",
  "settings.runSetup": "重新运行配置向导",
  "settings.appearance.title": "外观与语言",
  "settings.appearance.lead": "切换后立即应用，并在下次启动时保持。",
  "settings.theme.title": "界面主题",
  "settings.theme.detail": "原生终端保留 Provider 自己的终端配色。",
  "settings.theme.dark": "深色",
  "settings.theme.light": "浅色",
  "settings.language.title": "界面语言",
  "settings.language.detail": "默认跟随操作系统和浏览器语言。",
  "settings.provider.lead": "这些配置直接作用于新启动和恢复的会话。",
  "settings.provider.refresh": "重新检查",
  "settings.provider.loading": "正在读取 Provider…",
  "settings.provider.emptyInventory": "还没有配置 Agent",
  "settings.provider.emptyInventoryDetail": "添加或启用 Agent 后，才能创建新的会话。",
  "settings.projectRoot.title": "OrniWork 项目目录",
  "settings.projectRoot.lead": "新会话默认在此目录下创建独立工作区。",
  "settings.access.title": "远程访问边界",
  "settings.access.lead": "限制 Cloud 和手机端能够访问这台电脑的范围。",
  "settings.access.directory.title": "权限目录",
  "settings.access.directory.detail": "远程目录浏览和会话工作区只能位于此根目录内，本机 Desktop 操作不受影响。",
  "settings.defaultPermission.title": "默认会话权限",
  "settings.defaultPermission.detail": "所有新会话默认使用此权限，创建前仍可单独调整。",
  "settings.computerName.title": "电脑名称",
  "settings.computerName.detail": "Cloud 和手机端选择电脑时显示；离开输入框后立即保存。",
  "settings.computerName.placeholder": "为这台电脑命名",
  "settings.access.saved": "访问设置已保存",
  "settings.access.saveFailed": "访问设置保存失败",
  "settings.service.title": "本地服务",
  "settings.service.lead": "Daemon 负责 Provider 生命周期、PTY 历史和异常恢复。",
  "settings.service.detail": "所有 Provider 子进程由同一个本地服务托管。",
  "settings.service.online": "在线",
  "settings.service.offline": "离线",
  "settings.credentials.title": "凭据保护",
  "settings.credentials.detail": "API Key 只写入本地配置，不返回页面、不进入工作台和日志。",
  "settings.credentials.local": "本地",
  "settings.command.install": "安装",
  "settings.command.upgrade": "升级",
  "settings.command.uninstall": "卸载",
  "settings.provider.uninstallConfirm": "要从这台电脑卸载此 Agent 吗？",
  "settings.provider.installConfirm": "要在这台电脑上安装此 Agent 吗？",
  "settings.provider.upgradeConfirm": "要在这台电脑上升级此 Agent 吗？",
  "settings.agentReceipt.accepted": "操作已受理",
  "settings.agentReceipt.running": "操作进行中",
  "settings.agentReceipt.succeeded": "操作已完成",
  "settings.agentReceipt.failed": "操作失败",
  "settings.agentReceipt.rejected": "操作已拒绝",
  "settings.agentReceipt.cancelObserve": "停止等待",
  "settings.agentReceipt.resumeObserve": "继续查看",
  "settings.agentReceipt.retry": "重试",
  "settings.command.detail": "该命令不会由 OrniWork 自动执行。请先核对命令，再复制到本机终端。",
  "settings.provider.updated": "Provider 状态已更新",
  "settings.provider.checkFailed": "检查失败",
  "settings.provider.saveFailed": "保存失败",
  "settings.provider.installed": "已安装",
  "settings.provider.notDetected": "未检测到安装",
  "settings.provider.enabled": "已启用",
  "settings.provider.disabled": "已停用",
  "settings.provider.notInstalled": "未安装",
  "settings.provider.enable": "启用 Provider",
  "settings.provider.disable": "停用 Provider",
  "settings.provider.enableConfirm": "要在这台电脑上启用此 Agent 吗？",
  "settings.provider.disableConfirm": "要停用此 Agent 吗？不会停止已有会话。",
  "settings.provider.executable": "程序位置",
  "settings.provider.executablePlaceholder": "输入可执行文件路径",
  "settings.provider.home": "主目录",
  "settings.provider.manageApi": "管理 API",
  "settings.provider.defaultModel": "默认模型",
  "settings.provider.defaultModelPlaceholder": "使用 Provider 默认值",
  "settings.provider.endpoint": "API 地址",
  "settings.provider.keyConfigured": "已配置，留空保持不变",
  "onboarding.detectFailed": "Provider 检测失败",
  "onboarding.providerRequired": "至少需要启用一个已安装且路径有效的 Provider。",
  "onboarding.providerSaveFailed": "Provider 配置保存失败",
  "onboarding.historyReadFailed": "历史会话读取失败",
  "onboarding.settingsSaveFailed": "设置没有保存",
  "onboarding.progress": "配置进度",
  "onboarding.step.providers": "连接 Agent",
  "onboarding.step.history": "导入记录",
  "onboarding.close": "关闭向导",
  "onboarding.providers.eyebrow": "第一次使用 · 连接本机工具",
  "onboarding.providers.title": "连接你正在使用的 Agent",
  "onboarding.providers.lead": "选择你平时使用的终端工具。OrniWork 只负责连接、记录和组织，不会改动 Provider 的原生会话。",
  "onboarding.providers.refresh": "重新检查",
  "onboarding.providers.installed": "已安装",
  "onboarding.providers.notInstalled": "未安装",
  "onboarding.providers.enable": ({ provider }) => `启用 ${provider}`,
  "onboarding.providers.executable": "程序位置",
  "onboarding.providers.executablePlaceholder": "输入可执行文件路径",
  "onboarding.providers.home": "主目录",
  "onboarding.providers.defaultModel": "默认模型",
  "onboarding.providers.defaultModelPlaceholder": "使用 Provider 默认值",
  "onboarding.providers.endpoint": "API 地址",
  "onboarding.providers.keyConfigured": "已配置，留空保持不变",
  "onboarding.providers.copyInstall": "复制安装命令",
  "onboarding.providers.checking": "正在检查本机工具…",
  "onboarding.providers.checkingShort": "正在检查 Provider",
  "onboarding.providers.checkFailed": "Provider 检查失败",
  "onboarding.providers.checkFailedShort": "暂不可用",
  "onboarding.providers.checkFailedDetail": "目标电脑没有返回已安装的工具。请检查连接后重试。",
  "onboarding.providers.retry": "重试",
  "onboarding.providers.emptyInventory": "没有收到 Provider 信息。请确认所选电脑在线后重试。",
  "onboarding.providers.managedCount": ({ count }) => `${count} 个工具将由 OrniWork 管理`,
  "onboarding.providers.managedLabel": "个工具将由 OrniWork 管理",
  "onboarding.providers.localOnly": "配置只保存在本机",
  "onboarding.providers.historyStays": "原生历史不会被移动",
  "onboarding.providers.rerun": "随时可以在设置中重新配置",
  "onboarding.providers.foot": "至少启用一个已安装的工具即可继续。详细路径和模型设置可以稍后调整。",
  "onboarding.history.eyebrow": "第二步 · 可选导入",
  "onboarding.history.title": "把已有记录接回来",
  "onboarding.history.lead": "按 Provider 和工作目录查看会话摘要。你也可以先完成设置，之后再导入项目。",
  "onboarding.history.discovered": "已发现会话",
  "onboarding.history.existing": "已有会话",
  "onboarding.history.selected": ({ selected, total }) => `已选择 ${selected} / ${total} 个；批量选择后仍可逐个调整。`,
  "onboarding.history.safeTitle": "已有会话不会丢失",
  "onboarding.history.scanDone": "扫描已完成。",
  "onboarding.history.scanRunning": "扫描在后台进行，不影响你完成设置。",
  "onboarding.history.safeDetail": "以后仍可按目录查看和导入历史。",
  "onboarding.footer.enabled": ({ count }) => `${count} 个 Provider 已启用`,
  "onboarding.footer.saving": "正在保存…",
  "onboarding.footer.continue": "继续",
  "onboarding.footer.finish": "完成设置",
  "onboarding.history.scopeLabel": ({ name }) => `${name} 下的会话`,
  "onboarding.history.providerLabel": ({ provider }) => `${provider} 会话`,
  "onboarding.history.noSummary": "没有摘要",
  "onboarding.history.readingTitle": "正在读取历史会话",
  "onboarding.history.readingDetail": "扫描期间可以继续使用其他设置。",
  "onboarding.history.errorTitle": "历史暂时无法读取",
  "onboarding.history.errorFallback": "读取失败，请重试。",
  "onboarding.history.retry": "重试",
  "onboarding.history.emptyTitle": "没有发现可导入的完整会话",
  "onboarding.history.emptyDetail": "不会影响新建会话或之后再次导入。",
  "onboarding.history.selectScope": ({ label }) => `选择${label}`,
  "onboarding.history.clearScope": ({ label }) => `取消选择${label}`,
  "onboarding.history.select": "全选",
  "onboarding.history.clear": "取消",
  "onboarding.history.timeout": "历史较多，读取等待超时。请重试，其他 Agent 不受影响。",
  "terminal.quick.continue": "继续当前工作",
  "terminal.quick.fix": "修复这个问题",
  "terminal.quick.analyze": "先分析再修改",
  "terminal.quick.alternatives": "还有更好的方案吗？",
  "terminal.quick.test": "运行测试并修复",
  "terminal.quick.review": "检查当前改动",
  "terminal.quick.summary": "总结进度和下一步",
  "terminal.inputFailed": "终端输入失败",
  "terminal.unavailable": "本地终端连接不可用",
  "terminal.oldRun": "这条输入来自较早的运行段，当前运行段没有对应的原生终端历史。",
  "terminal.promptFailed": "确认操作发送失败",
  "terminal.aria": "原生终端",
  "terminal.userInputs": "用户输入记录",
  "terminal.outputResume": "继续输出",
  "terminal.outputPause": "暂停输出",
  "terminal.follow": "跟随最新输出",
  "terminal.online": "终端在线",
  "terminal.reconnect": "重新连接",
  "terminal.connecting": "正在等待原生终端就绪…",
  "terminal.snapshotTimeout": "终端画面未能及时到达，请重新连接重试。",
  "terminal.controlAcquiring": "正在获取终端控制权…",
  "terminal.controlAcquired": "已获取终端控制权",
  "terminal.controlHeldElsewhere": "当前终端由其他设备控制。",
  "terminal.controlTakeover": "当前无控制权 · 点击获取",
  "terminal.disconnected": "终端连接中断，正在自动重连",
  "terminal.reconnectNow": "立即重连",
  "terminal.quick.title": "快捷命令",
  "terminal.copySelection": "复制选区",
  "terminal.up": "上",
  "terminal.down": "下",
  "terminal.keysCollapse": "收起终端按键",
  "terminal.keysShow": "显示终端按键",
  "terminal.historyLoading": "正在加载终端历史…",
  "terminal.attachImage": "向终端添加图片",
  "terminal.imageUploading": "正在上传图片",
  "terminal.imageReady": "图片路径已插入",
  "terminal.removeImage": "移除图片",
  "terminal.imageTypeUnsupported": "请使用 PNG、JPEG 或 WebP 图片。",
  "terminal.imageTooLarge": "图片必须小于 10 MB。",
  "terminal.imageUnavailable": "此终端暂不支持图片上传。",
  "recovery.saveFailed": "异常恢复设置保存失败",
  "recovery.enableTitle": "启用异常恢复",
  "recovery.enableDetail": "临时容量不足、网络错误、可恢复失败或 Provider 异常退出时自动恢复。",
  "recovery.window": "恢复时长",
  "recovery.interval": "重试间隔",
  "recovery.minute": ({ count }) => `${count} 分钟`,
  "recovery.second": ({ count }) => `${count} 秒`,
  "recovery.foreverTitle": "一直重试",
  "recovery.foreverDetail": "忽略恢复时长，直到恢复成功、关闭异常恢复或明确停止会话。",
  "recovery.attemptsUsed": ({ count }) => `本次异常恢复已尝试 ${count} 次`,
  "recovery.saving": "保存中…",
  "recovery.save": "保存设置",
  "recovery.saved": "设置已保存",
  "recovery.noTriggerHint": "等待问题、权限确认和用户中断不会触发异常恢复。",
  "recovery.settingsEyebrow": "设置",
  "recovery.title": "异常恢复",
  "recovery.pageLead": "统一保护这个 Work 的主控和 Worker 会话，在临时故障或异常退出后恢复原本正在处理的工作。",
  "recovery.allEnabled": "全部开启",
  "recovery.partlyEnabled": "部分或全部关闭",
  "recovery.policyTitle": "恢复策略",
  "recovery.policyLead": "保存后应用到当前 Work 的主控和全部 Worker；以后新建的 Worker 默认开启异常恢复。",
  "recovery.sessionsTitle": "受保护的会话",
  "recovery.sessionsLead": "主控与 Worker 使用同一套恢复边界，等待用户和正常停止不会被重新启动。",
  "recovery.sessionCount": ({ count }) => `${count} 个会话`,
  "recovery.coordinator": "主控",
  "recovery.enabled": "已开启",
  "recovery.disabled": "已关闭",
  "recovery.recovering": ({ count }) => `正在恢复 · 第 ${count} 次`,
  "recovery.historyTitle": "恢复记录",
  "recovery.historyLead": "记录真实触发过的异常和恢复结果，不包含正常等待、用户输入或正常工作进度。",
  "recovery.recordCount": ({ count }) => `${count} 条`,
  "recovery.historyEmpty": "还没有触发过异常恢复",
  "recovery.dialogLead": "会话异常中断时恢复当前请求，正常完成或等待你回复时不会自行继续。",
  "recovery.dialogAria": "异常恢复设置",
  "recovery.outcome.scheduled": "等待恢复",
  "recovery.outcome.dispatched": "已发送恢复请求",
  "recovery.outcome.succeeded": "恢复成功",
  "recovery.outcome.cancelled": "已取消",
  "recovery.outcome.failed": "恢复失败",
  "recovery.attemptNumber": ({ count }) => `第 ${count} 次`,
  "recovery.issue.capacity": "模型容量暂时不足",
  "recovery.issue.rateLimit": "请求频率暂时受限",
  "recovery.issue.timeout": "Provider 连接超时",
  "recovery.issue.processExit": "Provider 进程异常退出",
  "recovery.issue.fallback": "Provider 临时异常",
  "help.kicker": "OrniWork 帮助",
  "help.title": "让 CLI Agent 真正持续工作",
  "help.lead": "OrniWork 管理你电脑上的 AI 编程会话，让你不必一直守在终端前，也不会在复杂工作里丢掉上下文。",
  "help.free": "桌面端核心能力完全免费",
  "help.problem.interruptedTitle": "会话突然中断",
  "help.problem.interruptedDetail": "自动识别、重试并恢复工作",
  "help.problem.remoteTitle": "必须守在电脑旁",
  "help.problem.remoteDetail": "远程服务接入后支持手机控制",
  "help.problem.complexTitle": "复杂任务容易失控",
  "help.problem.complexDetail": "持续维护需求、计划和进度",
  "help.capability.eyebrow": "主要特性",
  "help.capability.title": "把 Agent 托管给 OrniWork",
  "help.capability.lead": "你仍然使用熟悉的原生 CLI，OrniWork 负责会话之外容易被忽略的持续管理。",
  "help.capability.0.title": "离开电脑，会话继续",
  "help.capability.0.detail": "OrniWork 基于你电脑上的 Codex、Claude Code、OpenCode 等 CLI 工具托管会话。异常中断时自动识别和重试，桌面应用退出后会话仍可在后台持续工作。",
  "help.capability.0.feature0": "异常中断自动恢复",
  "help.capability.0.feature1": "卡住和长时间无响应提醒",
  "help.capability.0.feature2": "恢复状态与尝试记录",
  "help.capability.1.title": "移动端与远程连接",
  "help.capability.1.detail": "移动端查看和回复会话需要后续远程连接服务。当前版本先完成本地桌面会话和工作台管理。",
  "help.capability.1.feature0": "规划：实时查看会话输出",
  "help.capability.1.feature1": "规划：回答确认和选择问题",
  "help.capability.1.feature2": "规划：通过当前会话远程发送消息",
  "help.capability.2.title": "历史会话不再难找",
  "help.capability.2.detail": "不必记住工作目录或在大量未命名记录中猜测。OrniWork 按目录统一发现完整历史，可跨 Provider 导入、切换和继续。",
  "help.capability.2.feature0": "会话统一命名和排序",
  "help.capability.2.feature1": "本机跨 Provider 导入",
  "help.capability.2.feature2": "从会话列表直接继续",
  "help.capability.3.title": "熟悉的 CLI 完整保留",
  "help.capability.3.detail": "终端样式、斜杠命令、键盘操作和 Provider 自带能力仍然可用。需要完整细节时，随时回到原生终端继续操作。",
  "help.capability.3.feature0": "完整原生终端",
  "help.capability.3.feature1": "保留 Provider 内置命令",
  "help.capability.3.feature2": "桌面端直接操控",
  "help.capability.4.title": "重要上下文不会丢",
  "help.capability.4.detail": "OrniWork 持续维护任务事实、需求变更和工作上下文。会话被压缩、中断或换一个 Agent 接手时，所需信息可以重新注入。",
  "help.capability.4.feature0": "上下文恢复与重新注入",
  "help.capability.4.feature1": "需求和口径变更记录",
  "help.capability.4.feature2": "跨会话连续工作",
  "help.capability.5.title": "复杂工作也能看清",
  "help.capability.5.detail": "需求、计划、Todo、进度和待确认事项由 OrniWork 自动整理。复杂会话可以拆成更小的工作单元，并持续维护彼此的依赖和结果。",
  "help.capability.5.feature0": "完整 Todo、需求与计划",
  "help.capability.5.feature1": "进度和待确认事项归集",
  "help.capability.5.feature2": "复杂任务拆解与协作",
  "help.compare.eyebrow": "与直接使用 Native 对比",
  "help.compare.title": "不改变 Agent，只补上持续工作的控制面",
  "help.compare.native": "直接使用 Native",
  "help.compare.orni": "使用 OrniWork",
  "help.compare.0.native": "会话分散在不同目录和 Provider",
  "help.compare.0.orni": "按目录统一发现、导入和切换",
  "help.compare.1.native": "长输出里手动寻找进度和结论",
  "help.compare.1.orni": "进度、确认、文档和变更结构化呈现",
  "help.compare.2.native": "中断后手动恢复并重新说明上下文",
  "help.compare.2.orni": "异常恢复和权威工作信息重新注入",
  "help.enhance.eyebrow": "OrniWork 操作增强",
  "help.enhance.title": "保留原生 CLI，也让会话更容易查看和控制",
  "help.enhance.lead": "这些能力是每个会话都可以使用的查看与操作方式；Orni Work 还会按需维护工作文档。",
  "help.enhance.0.title": "原生终端与简约视图",
  "help.enhance.0.detail": "随时切换完整原生 CLI 和对话式简约视图；简约视图只保留用户输入、关键进展与结论。",
  "help.enhance.1.title": "输入记录与自动定位",
  "help.enhance.1.detail": "按时间查看用户发送过的指令，点击任意一条即可跳到原生终端或简约视图中的对应位置。",
  "help.enhance.2.title": "跨 Provider 会话",
  "help.enhance.2.detail": "Codex、Claude Code 和 OpenCode 会话统一呈现；完整历史按目录导入，不拆成第二套流程。",
  "help.enhance.3.title": "跟随输出与回看历史",
  "help.enhance.3.detail": "工作时自动跟随最新输出；向上浏览历史后保持当前位置，需要时再一键回到最新进度。",
  "help.enhance.4.title": "输入跟随当前会话",
  "help.enhance.4.detail": "终端与简约视图共享同一个会话，在当前页面输入或选择回答即可，Orni 会自动把内容送到对应会话。",
  "help.enhance.5.title": "长回复按需展开",
  "help.enhance.5.detail": "简约视图默认收起过长回复，也可展开单条消息或临时显示全部内容，减少滚动和信息干扰。",
  "help.services.eyebrow": "工具与服务",
  "help.services.title": "从安装到用量，一处管理",
  "help.services.0.title": "CLI 工具管理",
  "help.services.0.detail": "帮助安装、检查和升级 Codex、Claude Code、OpenCode 等 Provider。",
  "help.services.1.title": "Token 消耗管理",
  "help.services.1.detail": "按会话和 Provider 查看 Token 使用情况，避免预算失控。",
  "help.services.2.title": "API 与代理",
  "help.services.2.detail": "需要大模型 API 时可直接购买；同时提供本地 CLI 配置、API 代理和免重启切换。",
  "help.services.3.title": "本地优先",
  "help.services.3.detail": "会话和核心能力运行在你的电脑上，本地使用不要求登录 OrniWork 账户。",
  "help.modes.eyebrow": "会话方式",
  "help.modes.title": "同一项工作，按需要逐步展开",
  "help.modes.native": "完整保留原生终端体验，OrniWork 负责托管、历史索引和只读观察，不主动改变你的工作方式。",
  "help.modes.orni": "在会话之上按需维护目标、需求、计划、Todo、上下文、进度和变更；工作可以从简单开始，再逐步深入。",
  "help.faq.eyebrow": "常见问题",
  "help.faq.title": "开始前你可能想知道",
  "help.faq.0.q": "OrniWork 会替代 Codex 或 Claude Code 吗？",
  "help.faq.0.a": "不会。OrniWork 直接管理你电脑上已经安装的 CLI 工具，原生会话和原有能力始终保留；当前增加的是本地持续托管和工作信息管理。",
  "help.faq.1.q": "电脑关机后，手机还能控制会话吗？",
  "help.faq.1.a": "不能。当前版本尚未开放完整的手机远程控制；后续远程服务也要求托管会话的电脑保持开机并联网。",
  "help.faq.2.q": "桌面端需要付费或登录吗？",
  "help.faq.2.a": "桌面端核心能力完全免费，本地使用无需登录。远程连接、多设备同步、模型 API 和部分网络服务可能需要账户或单独购买。",
  "help.faq.3.q": "OrniWork 会上传我的完整代码和会话吗？",
  "help.faq.3.a": "本地终端和会话由 OrniWork 在你的电脑上管理。只有启用远程查看或网络服务时，相关数据才会按你授权的范围传输；具体权限会在启用前明确展示。",
  "help.faq.4.q": "目前支持哪些 AI 编程工具？",
  "help.faq.4.a": "产品架构面向 Codex、Claude Code、OpenCode 和后续 Provider。不同工具的结构化事件、恢复方式和高级能力会由独立 Adapter 适配。",
  "help.faq.5.q": "API 代理的“免重启切换”是什么？",
  "help.faq.5.a": "启用 Orni 的本地 API 配置与代理后，可以在统一入口切换模型 API 和路由策略，不必逐个退出并重启 CLI。该网络服务与免费的本地核心相互独立。",
  "session.back": "返回",
  "session.nameSave": "保存名称",
  "session.nameCancel": "取消改名",
  "session.rename": "重命名会话",
  "session.executionReadonly": "执行会话 · 只读",
  "session.native": "原生会话",
  "session.recovery": "异常恢复",
  "session.stop": "停止会话",
  "session.startConnect": "启动并连接",
  "session.restart": "重启会话",
  "session.localCommandShow": "显示本机打开命令",
  "session.more": "更多",
  "session.upgrade.title": "升级为 Orni Work",
  "session.upgrade.menuDetail": "保留当前会话，开始维护工作台",
  "session.organize.title": "整理工作台",
  "session.organize.detail": "让主控重新核对已有信息",
  "session.stopConfirm": "停止会话？",
  "session.restartConfirm": "重启会话？",
  "session.stopDetail": "当前 Provider 进程会停止，已保存的会话历史不会删除。",
  "session.restartDetail": "当前 Provider 进程会重启，正在运行的操作可能被中断。",
  "session.localCommand.title": "在本机打开这个会话",
  "session.localCommand.detail": "在本机终端运行下面的命令，会进入相同的受控会话。",
  "session.directory.view": "查看当前目录",
  "session.directory.viewDetail": "这是当前会话使用的工作目录。",
  "session.directory.new": "在当前目录新建会话",
  "session.directory.newDetail": "选择 Provider，在这个目录直接打开新的原生会话。",
  "session.upgrade.lead": "保留当前会话，并让它成为负责维护工作台和协调工作的主控会话。",
  "session.upgrade.current": "当前会话",
  "session.upgrade.currentDetail": "作为已有上下文自动带入",
  "session.upgrade.sources": "允许主控参考",
  "session.upgrade.document": "文档",
  "session.upgrade.code": "代码",
  "session.upgrade.other": "其他",
  "session.upgrade.pending": "正在升级…",
  "session.upgrade.confirm": "确认升级",
  "session.starting.createTitle": "正在创建会话",
  "session.starting.providerTitle": ({ provider }) => `正在启动 ${provider}`,
  "session.starting.createDetail": "正在准备工作目录并连接 Provider…",
  "session.starting.providerDetail": "Provider 准备完成后会自动显示原生终端，无需手动重连。",
  "session.starting.initialMessage": "你的消息",
  "session.inactive.error": ({ provider }) => `${provider} 连接异常`,
  "session.inactive.exited": ({ provider }) => `${provider} 已退出`,
  "session.inactive.title": "会话尚未启动",
  "session.inactive.workerDetail": "这个执行会话当前未运行，请返回主控会话查看工作安排。",
  "session.inactive.detail": ({ provider }) => `启动后会启动并连接 ${provider} 原生终端。`,
  "session.simple.you": "你",
  "session.simple.sending": "正在发送…",
  "session.simple.sent": "已发送",
  "session.simple.failed": "发送失败",
  "session.simple.retry": "重新发送",
  "session.simple.collapse": "收起",
  "session.simple.expand": "展开",
  "session.simple.copy": "复制",
  "session.simple.empty": "发送第一条消息，简约视图会按对话展示结果。",
  "session.simple.recovery.capacity": "当前模型容量暂时不足，正在异常恢复",
  "session.simple.recovery.rateLimit": "请求暂时受限，正在异常恢复",
  "session.simple.recovery.timeout": "连接暂时超时，正在异常恢复",
  "session.simple.recovery.unavailable": "服务暂时不可用，正在异常恢复",
  "session.simple.recoveryAttempt": ({ count }) => `第 ${count} 次`,
  "session.simple.turnFailed": "本轮处理失败，可重新发送或调整异常恢复设置。",
  "session.simple.follow": "跟随最新输出",
  "session.simple.expandLong": "展开长消息",
  "session.simple.collapseLong": "折叠长消息",
  "session.simple.toolActivity": "工具活动",
  "session.simple.toolRunning": "正在运行",
  "session.simple.toolCompleted": "已完成",
  "session.simple.toolFailed": "执行失败",
  "session.simple.toolInput": "输入",
  "session.simple.toolOutput": "输出",
  "session.simple.toolError": "错误",
  "session.simple.toolExitCode": "退出码",
  "session.simple.turnActive": "Agent 正在处理",
  "session.simple.queueTitle": "等待 Agent 接收",
  "session.simple.queueQueued": "已进入本地队列",
  "session.simple.queueRelayAccepted": "Cloud 中继已接收",
  "session.simple.queueDaemonAccepted": "电脑已接收",
  "session.simple.queueProviderAccepted": "Agent 已接收",
  "session.simple.queueIndeterminate": "正在核对发送状态",
  "session.simple.queueCancelled": "已取消",
  "session.composer.readonly": "执行会话只读，请在主控会话中继续。",
  "session.composer.placeholder": "继续对话…",
  "session.composer.aria": "发送到主控会话",
  "session.composer.send": "发送",
  "session.composer.startingToSend": "正在启动会话，消息会自动发送",
  "session.composer.resumedAndSent": "会话已恢复，消息已发送",
  "session.composer.imageAttachment": "图片附件",
  "session.composer.addAttachment": "添加图片",
  "session.composer.removeAttachment": "移除图片",
  "session.composer.attachmentsUnsupported": "当前 Agent 不支持图片附件。",
  "session.composer.attachmentsLimit": "每条消息最多添加 4 张图片。",
  "session.composer.attachmentsTypeUnsupported": "仅支持 PNG、JPEG 和 WebP 图片。",
  "session.composer.attachmentsTooLarge": "图片超过 10 MB 大小限制。",
  "session.question.singleAnswer": ({ question, answer }) => `关于“${question}”，我的回答是：${answer}`,
  "session.question.multiIntro": "我统一回答以下问题：",
  "session.question.answerLabel": "回答",
  "session.question.answerLine": ({ answer }) => `回答：${answer}`,
  "session.question.answeredCount": ({ count }) => `已回答 ${count} 个问题`,
  "session.question.answered": "已回答",
  "session.question.syncing": "回答已发送，正在同步记录",
  "session.question.saved": "问题与回答已保留在当前会话",
  "session.question.label": "问题",
  "session.question.groupTitle": "请确认这组问题",
  "session.question.title": "需要你确认",
  "session.question.groupProgress": ({ current, total }) => `${current} / ${total} · 全部回答后一次发送`,
  "session.question.singleDetail": "回答会回到同一个主控会话",
  "session.question.recommendation": "建议",
  "session.question.other": "其他回答",
  "session.question.placeholder": "直接说你的想法…",
  "session.question.readonly": "请在主控会话中统一处理",
  "session.question.previous": "上一个",
  "session.question.next": "下一个",
  "session.question.submitAll": "提交全部回答",
  "session.question.submit": "发送回答",
  "session.prompt.title": "需要你确认",
  "session.prompt.detail": "Provider 正在等待选择",
  "session.prompt.readonly": "执行会话只读，请在主控会话中处理。",
  "session.prompt.hint": "选择会直接发送到当前原生会话，不会改写成普通聊天消息。",
  "session.prompt.openTerminal": "查看原生终端",
  "session.tools.expand": "展开会话工具",
  "session.tools.collapse": "收起会话工具",
  "session.list.show": "显示会话列表",
  "session.list.hide": "隐藏会话列表",
  "session.work.createTitle": "建立 Orni 工作台",
  "session.work.createDetail": "Orni Work 会从当前会话开始维护目标、计划、上下文和进度，原生终端仍然保留。",
  "session.work.createAction": "开始管理这项工作",
  "session.work.upgradeTitle": "把当前会话升级为 Orni Work",
  "session.work.upgradeDetail": "保留这段原生会话和 Provider 历史，在同一个会话里开始维护工作文档、Round、进度和变更。",
  "session.work.upgradePending": "正在连接主控…",
  "session.work.upgradeAction": "选择来源并升级",
  "session.upgrade.failed": "当前会话没有升级成功。",
  "app.time.justNow": "刚刚",
  "app.operationFailed": "操作未完成。",
  "app.session.creatingCoordinator": "正在建立主控会话",
  "app.session.creatingProject": "正在创建项目会话",
  "app.session.detailLoadFailed": "会话详情读取失败。",
  "app.session.coordinatorReady": "主控会话已建立，正在理解你的目标。",
  "app.session.createFailed": "会话未创建。",
  "session.starting.createErrorTitle": "会话创建失败",
  "session.starting.createErrorDetail": "创建请求未能完成。你的输入仍保留在此页面，可以返回后重新创建。",
  "app.session.importReading": "已进入会话，正在读取你选择的已有信息…",
  "app.session.preparingProvider": "会话已创建，正在准备 Provider…",
  "app.session.opening": "正在打开会话",
  "app.session.openingDetail": "正在读取原生终端和会话记录…",
  "app.session.openFailed": "无法打开这个会话",
  "app.session.backToWorkbench": "返回工作台",
  "app.notice.recoverySaved": "异常恢复设置已保存",
  "app.notice.sessionRenamed": "会话名称已更新",
  "app.notice.sessionStarted": "会话已启动",
  "app.notice.sessionStopped": "会话已停止",
  "app.notice.allSessionsStopped": "全部会话已停止",
  "app.notice.sessionRestarted": "会话已重启",
  "app.notice.sessionDeleted": "会话已删除",
  "app.notice.sessionRootSaved": "会话根目录已保存",
  "app.historyImport.accepted": ({ count, provider }) => `正在后台导入 ${provider} 的 ${count} 个会话…`,
  "app.historyImport.completed": ({ count, provider }) => `已导入 ${provider} 的 ${count} 个会话`,
  "app.historyImport.failed": ({ count, provider }) => `${provider} 的 ${count} 个会话导入失败`,
  "create.history.providerScoped": "只查询这个 Agent 的历史会话",
  "runtime.error.workspaceRequired": "请选择有效的工作目录。",
  "runtime.error.noWorkToRefresh": "当前会话还没有可整理的 Orni Work。",
  "runtime.error.upgradeFailed": "当前会话没有成功启用 Orni Work。",
  "runtime.error.noWorkToTransfer": "当前主控没有可交接的 Orni Work。",
  "runtime.error.cloudDeviceRequired": "请先登录并连接这台电脑，再创建 Orni Work。",
  "runtime.error.coordinatorBindingChanged": "主控已在其他设备发生变化，请刷新后再更换。",
  "runtime.error.sessionNameRequired": "会话名称不能为空。",
  "runtime.error.attentionUnavailable": "待处理事项已不存在或已被其他客户端处理。",
  "runtime.session.connecting": ({ provider }) => `正在连接 ${provider}`,
  "runtime.session.newCoordinatorTitle": ({ title }) => `${title} · 新主控`,
  "runtime.session.fallbackTitle": ({ provider, id }) => `${provider} 会话 ${id}`,
  "runtime.session.providerSession": ({ provider }) => `${provider} 会话`,
  "runtime.session.workerActive": ({ provider }) => `${provider} 会话正在工作`,
  "runtime.session.workerUpdated": ({ provider }) => `${provider} 会话状态更新`,
  "runtime.attention.confirmDelivery": "确认交付",
  "runtime.attention.confirmContinue": "确认继续",
  "runtime.attention.requestChanges": "需要调整",
  "runtime.round.notStarted": "尚未开始",
  "runtime.round.awaitingReview": "Agent 已报告完成，等待 Review",
  "runtime.owner.currentRun": "当前 Run",
  "runtime.stage.execution": "执行",
  "runtime.capability.structuredProgress": "结构化进度",
  "runtime.capability.recovery": "异常恢复",
  "runtime.impact.materials": ({ count }) => `${count} 份资料`,
  "runtime.impact.entities": ({ count }) => `${count} 个条目`,
  "runtime.impact.rounds": ({ count }) => `${count} 个后续 Round`,
  "runtime.impact.assignments": ({ count }) => `${count} 个任务`,
  "runtime.impact.sessions": ({ count }) => `${count} 个会话`,
  "runtime.impact.operations": ({ count }) => `${count} 项操作`,
  "runtime.listSeparator": "、",
  "runtime.document.entityCount": ({ count, kind }) => `${count} 个${kind}`,
  "runtime.entity.goal": "目标",
  "runtime.entity.requirement": "需求",
  "runtime.entity.constraint": "约束",
  "runtime.entity.deliverable": "交付物",
  "runtime.entity.acceptance": "验收标准",
  "runtime.entity.architecture": "架构",
  "runtime.entity.design": "设计",
  "runtime.entity.audience": "用户",
  "runtime.entity.scenario": "场景",
  "runtime.entity.risk": "风险",
  "runtime.entity.decision": "决策",
  "runtime.entity.unknown": "待明确",
  "runtime.material.strategy": "策略",
  "runtime.material.overview": "概览",
  "runtime.material.title.workOverview": "工作概览",
  "runtime.material.title.workStrategy": "工作策略",
  "runtime.material.technical": "技术",
  "runtime.material.design": "设计",
  "runtime.material.standards": "规范",
  "runtime.material.delivery": "交付",
  "runtime.material.acceptance": "验收",
  "runtime.material.other": "资料",
  "runtime.activity.toolsWithFiles": ({ tools, files }) => `已记录 ${tools} 次工具活动，其中 ${files} 次文件修改`,
  "runtime.activity.tools": ({ count }) => `已记录 ${count} 次工具活动`,
  "runtime.activity.agentRunning": ({ detail }) => `Agent 正在执行 · ${detail}`,
  "runtime.activity.starting": "正在启动 Provider",
  "runtime.activity.stopping": "正在停止 Provider",
  "runtime.activity.stopped": "已停止，可以重新启动",
  "runtime.activity.exited": "Provider 已退出",
  "runtime.activity.error": "Provider 启动或运行异常",
  "runtime.activity.terminalRunning": "原生终端正在运行",
  "runtime.report.startedStage": ({ stage }) => `开始：${stage}`,
  "runtime.report.started": "Worker 已开始工作",
  "runtime.report.progressStage": ({ stage }) => `阶段进展：${stage}`,
  "runtime.report.progress": "Worker 提交阶段进展",
  "runtime.report.resultStage": ({ stage }) => `阶段结果：${stage}`,
  "runtime.report.result": "Worker 提交阶段结果",
  "runtime.report.waitingInput": "Worker 等待补充信息",
  "runtime.report.waitingApproval": "Worker 等待确认",
  "runtime.report.waitingDependency": "Worker 等待依赖",
  "runtime.report.problem": "Worker 工作遇到问题",
  "runtime.report.completed": "Worker 提交完成结果",
  "runtime.report.cancelled": "Worker 工作已取消",
  "runtime.report.updateStage": ({ stage }) => `进展：${stage}`,
  "runtime.report.update": "Worker 更新工作进展",
  "runtime.report.step": ({ current, total }) => `步骤 ${current}/${total}`,
  "runtime.report.completedItems": ({ items }) => `已完成：${items}`,
  "runtime.report.next": ({ action }) => `接下来：${action}`,
  "runtime.report.question": ({ question }) => `需要确认：${question}`,
  "runtime.report.statusUpdate": "Worker 已提交状态更新。",
  "runtime.sessionLeg.preparing": "准备中",
  "runtime.sessionLeg.active": "正在工作",
  "runtime.sessionLeg.completed": "已完成",
  "runtime.sessionLeg.failed": "执行失败",
  "runtime.sessionLeg.replaced": "已交接",
  "runtime.sessionLeg.detached": "已脱离",
  "runtime.sessionLeg.unknown": "状态待确认",
  "runtime.assignment.proposed": "等待接受",
  "runtime.assignment.active": "正在执行",
  "runtime.assignment.paused": "已暂停",
  "runtime.assignment.completed": "已完成",
  "runtime.assignment.replaced": "已转交",
  "runtime.assignment.revoked": "已撤销",
  "runtime.daemon.offline": "本地 Daemon 不可用",
  "runtime.native.starting": "正在启动本地服务",
  "runtime.native.startingDetail": "Orni 正在连接本地 Daemon…",
  "runtime.native.offline": "本地服务不可用",
  "runtime.native.offlineDetail": "Desktop 已打开，但本地 Daemon 没有响应。",
  "runtime.native.retry": "重新连接",
  "workbench.aria": "工作台导航",
  "workbench.pageAria": "工作台页面",
  "workbench.nav.work": "工作",
  "workbench.nav.overview": "总览",
  "workbench.nav.rounds": "进度管理",
  "workbench.nav.sessions": "会话管理",
  "workbench.nav.confirmations": "信息确认",
  "workbench.nav.mutations": "变更记录",
  "workbench.nav.documents": "工作文档",
  "workbench.nav.settings": "设置",
  "workbench.nav.recovery": "异常恢复",
  "workbench.nav.organize": "整理会话",
  "workbench.documents.empty": "主控会话会按实际需要建立文档。",
  "workbench.overview.revision": ({ revision }) => `工作总览 · rev ${revision}`,
  "workbench.overview.workerLatest": "最新 Worker 动态",
  "workbench.overview.currentFocus": "当前重点",
  "workbench.overview.noRound": "尚未安排工作轮次",
  "workbench.overview.openRound": "查看轮次",
  "workbench.overview.recentRecords": "最近工作记录",
  "workbench.overview.allRecords": "查看完整记录",
  "workbench.scope.all": "工作整体",
  "workbench.overview.currentRound": "当前轮次",
  "workbench.overview.awaitingPlan": "等待安排",
  "workbench.overview.allRounds": "查看全部工作轮次",
  "workbench.overview.workSessions": "工作会话",
  "workbench.overview.activeSessions": ({ count }) => `${count} 个正在工作`,
  "workbench.overview.noActiveSessions": "当前没有活动会话",
  "workbench.overview.sessionHistory": "查看当前和历史记录",
  "workbench.overview.confirmations": "信息确认",
  "workbench.overview.pendingCount": ({ count }) => `${count} 项待处理`,
  "workbench.overview.noPending": "没有待确认事项",
  "workbench.overview.confirmationHistory": "查看确认历史",
  "workbench.overview.recentChanges": "最近变化",
  "workbench.overview.noChanges": "尚无变化",
  "workbench.overview.allChanges": "查看所有信息的变化记录",
  "workbench.overview.roundsTitle": "工作轮次",
  "workbench.overview.roundsLead": "从整体安排定位当前正在做什么，以及后面准备得到什么。",
  "workbench.overview.viewAll": "查看全部",
  "workbench.overview.roundsEmpty": "还没有工作轮次。继续与主控会话讨论，安排会在这里出现。",
  "workbench.rounds.eyebrow": "进度管理",
  "workbench.rounds.title": "一轮一轮看清楚工作的推进",
  "workbench.rounds.lead": "轮次是可伸缩的执行容器；新的想法和变更由主控会话判断归入当前、后续或新的轮次。",
  "workbench.rounds.latest": ({ detail }) => `最新：${detail}`,
  "workbench.rounds.currentVersion": "当前版本",
  "workbench.rounds.awaitingStart": "等待本轮工作开始",
  "workbench.rounds.completion": "完成条件",
  "workbench.rounds.criteriaCount": ({ count }) => `${count} 项`,
  "workbench.rounds.criteriaManaged": "由主控会话按工作需要维护",
  "workbench.rounds.workerLatest": "最新 Worker 动态",
  "workbench.rounds.workSessions": "工作会话",
  "workbench.rounds.noWorkerSessions": "当前没有关联的 Worker 会话",
  "workbench.rounds.updateCount": ({ count }) => `${count} 条工作动态`,
  "workbench.rounds.openDetail": "查看轮次详情",
  "workbench.rounds.emptyTitle": "还没有工作轮次",
  "workbench.rounds.emptyDetail": "轮次安排会由主控会话结合工作目标和用户确认动态建立。",
  "workbench.roundDetail.back": "返回工作轮次",
  "workbench.roundDetail.switch": "切换轮次",
  "workbench.roundDetail.overview": "总览",
  "workbench.roundDetail.sessions": "会话",
  "workbench.roundDetail.notes": "简要记录",
  "workbench.roundStatus.active": "进行中",
  "workbench.roundStatus.review": "等待验收",
  "workbench.roundStatus.completed": "已完成",
  "workbench.roundStatus.paused": "已暂停",
  "workbench.roundStatus.needsReview": "需要检查",
  "workbench.roundStatus.planned": "准备中",
  "workbench.overview.organizing": "主控会话正在整理这项工作的最新信息。",
  "workbench.sessions.eyebrow": "会话管理",
  "workbench.sessions.title": "主控与所有 Worker 会话",
  "workbench.sessions.lead": "先看每个会话的当前状态，也可以继续查看 Worker Master 跨轮次的详细工作记录。",
  "workbench.sessions.pauseAll": "暂停全部",
  "workbench.sessions.all": "全部会话",
  "workbench.sessions.activity": "详细工作记录",
  "workbench.sessions.coordinator": "主控会话",
  "workbench.sessions.authority": "工作台唯一负责人",
  "workbench.sessions.replaceCoordinator": "更换主控",
  "workbench.sessions.pause": "暂停",
  "workbench.sessions.replace": "更换",
  "workbench.sessions.readOnly": "只读查看",
  "workbench.sessions.emptyTitle": "没有关联会话",
  "workbench.sessions.emptyDetail": "主控分派 Worker 后，当前和历史会话会统一记录在这里。",
  "workbench.sessionHistory.active": "进行中",
  "workbench.sessionHistory.waiting": "等待",
  "workbench.sessionHistory.completed": "已完成",
  "workbench.sessionHistory.failed": "失败",
  "workbench.sessionHistory.replaced": "已替换",
  "workbench.activity.dispatch": "工作安排",
  "workbench.activity.review": "确认 / 验收",
  "workbench.activity.delivery": "结果",
  "workbench.activity.workerReport": "Worker 汇报",
  "workbench.activity.provider": "Provider 动态",
  "workbench.activity.latest": "最新",
  "workbench.activity.emptyTitle": "还没有工作记录",
  "workbench.activity.emptyDetail": "Worker 开始、阶段汇报、阻塞、验收和结果会按时间出现在这里。",
  "workbench.sources.eyebrow": "整理会话",
  "workbench.sources.title": "让主控重新了解当前工作",
  "workbench.sources.lead": "选择允许主控参考的来源。实际阅读、核对和后续确认都会回到原来的主控会话继续。",
  "workbench.sources.projectSources": "项目来源",
  "workbench.sources.documents": "文档",
  "workbench.sources.code": "代码",
  "workbench.sources.other": "其他",
  "workbench.sources.history": "补充历史会话",
  "workbench.sources.historyLead": "可选。主控只会参考你选中的完整会话。",
  "workbench.sources.refresh": "刷新",
  "workbench.sources.userMessages": ({ count }) => `${count} 条用户输入`,
  "workbench.sources.readingHistory": "正在读取这个目录关联的 Provider 历史…",
  "workbench.sources.noHistory": "没有找到可补充的历史会话。",
  "workbench.sources.request": "这次希望主控特别留意什么（可选）",
  "workbench.sources.requestPlaceholder": "例如：结合当前代码重新核对需求和技术文档。",
  "workbench.sources.contextIncluded": "当前主控会话和工作台会始终作为已知信息",
  "workbench.sources.submitting": "正在提交…",
  "workbench.sources.submit": "交给主控",
  "workbench.sources.historyError": "没有读取到可用的历史会话。",
  "workbench.sources.submitError": "整理请求没有提交成功。",
  "workbench.pause.aria": "暂停会话",
  "workbench.pause.error": "会话暂停失败。",
  "workbench.pause.titleAll": ({ count }) => `暂停全部 ${count} 个活动会话`,
  "workbench.pause.titleOne": ({ title }) => `暂停“${title}”`,
  "workbench.pause.lead": "选择只中断当前工作，或者退出整个 Provider 会话。",
  "workbench.pause.interrupt": "发送 Esc",
  "workbench.pause.interruptAll": "全部发送 Esc",
  "workbench.pause.interruptLead": "中断当前一轮工作，会话继续保留并可继续输入。",
  "workbench.pause.exit": "退出会话",
  "workbench.pause.exitAll": "退出全部会话",
  "workbench.pause.exitLead": "停止 Provider 进程，之后可以重新启动并恢复。",
  "workbench.handoff.coordinatorTitle": "更换主控会话",
  "workbench.handoff.coordinatorLead": "工作台、Round、问题、决策和 Worker 关系保持不变；旧主控保留为只读历史。",
  "workbench.handoff.coordinatorError": "主控会话没有完成接手。",
  "workbench.handoff.workerTitle": "更换 Worker",
  "workbench.handoff.workerLead": "新 Worker 会接收当前权威资料、前任汇报和同一项工作安排；旧会话保留为只读历史。",
  "workbench.handoff.workerError": "Worker 没有完成接手。",
  "workbench.handoff.workerSessionTitle": ({ title }) => `${title} · 接手`,
  "workbench.handoff.newProvider": "新的 Provider",
  "workbench.handoff.note": "接手说明（可选）",
  "workbench.handoff.notePlaceholder": "例如：接着当前进度处理，但先重新核对技术文档。",
  "workbench.handoff.reason": "更换原因（可选）",
  "workbench.handoff.reasonPlaceholder": "例如：当前会话异常退出，接着已有结果继续。",
  "workbench.handoff.pending": "正在接手…",
  "workbench.handoff.confirm": "确认更换",
  "workbench.roundNotes.current": "本轮当前版本",
  "workbench.roundNotes.changes": "安排与调整",
  "workbench.confirmations.eyebrow": "信息确认",
  "workbench.confirmations.title": "所有需要你决定的事情都在这里",
  "workbench.confirmations.lead": "回答会作为普通消息回到同一个主控会话；稍后和忽略只处理收件箱状态。",
  "workbench.confirmations.batch": "批量",
  "workbench.confirmations.single": "逐个",
  "workbench.confirmations.pending": "待确认",
  "workbench.confirmations.history": "历史记录",
  "workbench.confirmations.runtimeAlert": "运行提醒",
  "workbench.confirmations.deferred": "稍后处理",
  "workbench.confirmations.notePlaceholder": "补充说明，或输入其他答案…",
  "workbench.confirmations.answerPlaceholder": "输入你的回答…",
  "workbench.confirmations.later": "稍后再看",
  "workbench.confirmations.reopen": "恢复处理",
  "workbench.confirmations.ignore": "忽略",
  "workbench.confirmations.send": "发送回答",
  "workbench.confirmations.coordinator": "主控会话",
  "workbench.confirmations.previous": "上一个",
  "workbench.confirmations.next": "下一个",
  "workbench.confirmations.answeredCount": ({ answered, total }) => `已回答 ${answered} / ${total}`,
  "workbench.confirmations.sending": "正在发送…",
  "workbench.confirmations.submit": "提交",
  "workbench.confirmations.emptyTitle": "没有待确认事项",
  "workbench.confirmations.emptyDetail": "新的问题、Worker 请求、运行提醒和验收会集中出现在这里。",
  "workbench.confirmations.completed": "已完成",
  "workbench.confirmations.ignored": "已忽略",
  "workbench.confirmations.historyEmptyTitle": "还没有确认历史",
  "workbench.confirmations.historyEmptyDetail": "已完成和已忽略的事项会保留完整上下文。",
  "workbench.confirmations.answerSeparator": "；",
  "workbench.confirmations.singleAnswer": ({ prompt, answer }) => `关于“${prompt}”，我的回答是：${answer}`,
  "workbench.confirmations.batchAnswer": ({ answers }) => `我统一回答以下待确认事项：\n${answers}`,
  "workbench.confirmations.batchAnswerItem": ({ index, prompt, answer }) => `${index}. ${prompt}\n回答：${answer}`,
  "workbench.confirmations.sendError": "发送失败。",
  "workbench.confirmations.sendRetry": "发送失败，请重试。",
  "workbench.confirmations.statusError": "状态更新失败。",
  "workbench.documents.viewAria": "文档视图",
  "workbench.documents.openChanges": "查看变更",
  "workbench.documents.view.markdown": "文档",
  "workbench.documents.view.overview": "概览",
  "workbench.documents.view.table": "表格",
  "workbench.documents.view.tree": "结构",
  "workbench.documents.view.map": "关系",
  "workbench.documents.view.timeline": "时间线",
  "workbench.documents.view.board": "看板",
  "workbench.documents.view.slides": "逐页",
  "workbench.mutations.eyebrow": "变更记录",
  "workbench.mutations.title": "每一次变化为什么发生、具体改了什么",
  "workbench.mutations.lead": "批次视图还原一次交互影响的全部信息；平铺视图按信息逐条查看字段变化。",
  "workbench.mutations.clearFilter": "清除信息筛选",
  "workbench.mutations.batches": "按交互批次",
  "workbench.mutations.operations": "全部信息变化",
  "workbench.mutations.search": "按信息 ID 查询",
  "workbench.mutations.loading": "正在读取变更账本…",
  "workbench.mutations.retry": "重试",
  "workbench.mutations.emptyTitle": "还没有业务信息变化",
  "workbench.mutations.noMatchTitle": "没有匹配的信息变化",
  "workbench.mutations.emptyDetail": "纯内部版本和更新时间变化已自动隐藏。",
  "workbench.mutations.loadEarlier": "加载更早记录",
  "workbench.mutations.loadError": "无法读取变更记录。",
  "workbench.mutations.loadMoreError": "无法读取更多变更记录。",
  "workbench.mutations.changeCount": ({ count }) => `${count} 项业务变化`,
  "workbench.mutations.confirmed": "已关联用户确认",
  "workbench.mutations.trigger": "触发与确认",
  "workbench.mutations.system": "系统维护",
  "workbench.mutations.confirmationPrefix": "确认：",
  "workbench.mutations.raw": "查看完整原始记录",
  "workbench.mutations.before": "原来",
  "workbench.mutations.after": "现在",
  "workbench.mutations.unset": "未设置",
  "workbench.mutations.emptyValue": "空",
  "workbench.mutations.emptyString": "空字符串",
  "workbench.mutations.none": "无",
  "api.title": "API 管理",
  "api.lead": "统一配置 Codex、OpenCode 和 Claude Code 使用的模型接口。",
  "api.tab.config": "配置",
  "api.tab.monitor": "监控",
  "api.loading": "正在连接 API 服务",
  "api.loadingDetail": "独立的 Orni API Daemon 会在当前窗口关闭后继续运行。",
  "api.error.offline": "API 服务没有运行，请启动 Orni 本地服务后重试。",
  "api.error.action": "无法更新 API 设置。",
  "api.providers.title": "Provider",
  "api.providers.count": ({ count }) => `已配置 ${count} 个`,
  "api.providers.empty": "没有符合条件的 Provider",
  "api.providers.emptyDetail": "新增一个 API 来源，或清除当前筛选。",
  "api.filter.protocolAll": "全部协议",
  "api.filter.cliAll": "全部 CLI",
  "api.provider.add": "新增 Provider",
  "api.provider.update": "更新 Provider",
  "api.provider.edit": "编辑 Provider",
  "api.provider.editorLead": "除 Bedrock 外，名称、接口地址和协议为必填；凭据、默认模型、官网和备注均为可选。",
  "api.field.required": "必填",
  "api.provider.name": "名称",
  "api.provider.protocol": "协议类型",
  "api.provider.detectProtocol": "检测协议",
  "api.provider.protocolDetecting": "正在检测接口协议…",
  "api.provider.protocolDetected": ({ protocol }) => `已识别为 ${protocol}，其他已填写内容保持不变。`,
  "api.provider.protocolDetectFailed": "没有识别出这个接口使用的协议。",
  "api.provider.url": "接口地址",
  "api.provider.defaultModel": "默认模型",
  "api.provider.clearModel": "清空默认模型",
  "api.provider.modelPlaceholder": "输入模型 ID",
  "api.provider.homepage": "官网地址",
  "api.provider.notes": "备注",
  "api.provider.compatibility": "可用于",
  "api.provider.unsupported": "不支持",
  "api.provider.modelUnset": "未设置模型",
  "api.provider.keyStored": "已有凭据，留空会继续使用原凭据。",
  "api.provider.keyReplace": "输入新 Key 可替换当前凭据",
  "api.provider.keyPlaceholder": "仅保存在本机 API 数据库中",
  "api.provider.test": "测试",
  "api.provider.testEndpoint": "测试请求",
  "api.provider.testModel": "测试模型",
  "api.provider.testSuccess": "可用",
  "api.provider.testError": "失败",
  "api.provider.noStatus": "无 HTTP 状态",
  "api.provider.testing": "正在测试 Provider…",
  "api.provider.testComplete": "Provider 测试已完成。",
  "api.provider.testFailed": "Provider 测试失败。",
  "api.provider.models": "获取模型",
  "api.provider.modelsLoading": "正在读取模型列表…",
  "api.provider.modelsLoaded": ({ count }) => `已读取 ${count} 个模型。`,
  "api.provider.modelsAvailable": "可用模型",
  "api.provider.modelsEmpty": "接口没有返回任何模型。",
  "api.provider.modelsFailed": "无法读取模型列表。",
  "api.provider.deleteTitle": "删除这个 Provider？",
  "api.provider.deleteDetail": ({ name }) => `${name} 也会从所有 CLI 的使用顺序中移除。`,
  "api.proxy.title": "本地 API 代理",
  "api.proxy.runningDetail": "后台正在提供故障切换、健康恢复和请求监控。",
  "api.proxy.stoppedDetail": "仍可直接连接接口，但无法自动切换 Provider，也没有代理请求监控。",
  "api.proxy.port": "端口",
  "api.proxy.start": "开启代理",
  "api.proxy.stop": "关闭代理",
  "api.proxy.online": "运行中",
  "api.proxy.offline": "已停止",
  "api.proxy.keyUnavailable": "重启 API 服务后可读取代理 Key",
  "api.proxy.disableTitle": "关闭本地代理？",
  "api.proxy.disableDetail": "当前使用代理地址的 CLI 会暂时无法工作，直到代理再次开启。",
  "api.proxy.route.responses": "Responses 接口",
  "api.proxy.route.chat": "Chat 接口",
  "api.proxy.route.anthropic": "Anthropic 接口",
  "api.cli.codex.support": "Codex 的自定义 Provider 使用 OpenAI Responses 协议；Bedrock 使用原生 AWS 凭据。",
  "api.cli.opencode.support": "OpenCode 支持 OpenAI 兼容协议和 Anthropic 兼容协议。",
  "api.cli.claude.support": "Claude Code 使用 Anthropic Messages 协议，或原生 Bedrock 集成。",
  "api.cli.endpoint": "接口地址",
  "api.cli.directEndpoint": "所选 Provider 地址会直接写入 CLI 配置。",
  "api.mode.proxy": "使用代理",
  "api.mode.direct": "直接连接",
  "api.mode.proxyTitle": "推荐方式",
  "api.mode.proxyDetail": "请求优先使用第一个健康的已启用 Provider，失败时自动切换。",
  "api.mode.proxyOfflineTitle": "本地代理已关闭",
  "api.mode.proxyOfflineDetail": "当前 CLI 选择了使用代理；如果实际配置已指向代理地址，在重新开启代理前请求可能无法使用。",
  "api.mode.directTitle": "直接连接",
  "api.mode.directDetail": "只会使用第一个已启用 Provider，其他项目不生效，失败后也无法自动切换。",
  "api.direct.confirmTitle": "切换为直接连接？",
  "api.direct.confirmDetail": "这个 CLI 将不再获得自动故障切换和代理请求监控。",
  "api.routing.title": "Provider 使用顺序",
  "api.routing.proxyDetail": "拖动调整优先级；不可用的 Provider 会被跳过，恢复后重新参与。",
  "api.routing.directDetail": "直接连接模式只使用第一个已启用 Provider。",
  "api.routing.add": "添加 Provider",
  "api.routing.refresh": "刷新",
  "api.routing.recover": "测试并恢复路由",
  "api.routing.remove": "从路由移除",
  "api.routing.endpointReachable": "请求成功",
  "api.routing.endpointFailed": "请求失败",
  "api.routing.endpointScope": "真实模型请求，输出限制为 16 tokens。",
  "api.routing.pickerDetail": "选择一个兼容的 Provider，添加后立即生效。",
  "api.routing.noneAvailable": "没有其他兼容的 Provider。",
  "api.routing.empty": "尚未选择 Provider",
  "api.routing.emptyDetail": "更新 CLI 配置前，至少添加一个兼容的 Provider。",
  "api.routing.standbyDisabled": "直接连接时不生效",
  "api.routing.enable": "启用 Provider",
  "api.routing.disable": "停用 Provider",
  "api.routing.moveUp": "上移",
  "api.routing.moveDown": "下移",
  "api.current.view": "查看当前配置",
  "api.current.refresh": "刷新当前配置",
  "api.current.readFailed": "无法读取当前 CLI 配置。",
  "api.current.label": "CLI 当前实际配置",
  "api.current.proxyTitle": "已经在使用 Orni 代理",
  "api.current.proxyBadge": "正在使用代理",
  "api.current.matched": "匹配已保存的 Provider",
  "api.current.add": "添加到 Provider",
  "api.current.addDetail": "添加后会把这个接口及其现有凭据保存到 Orni 本机 API 数据库；兼容时放到当前 CLI 顺序的第一位，不会修改 CLI 配置文件。",
  "api.current.emptyTitle": "当前没有 API 配置",
  "api.current.emptyDetail": "没有从这个 CLI 中读取到受支持的当前 API 配置。",
  "api.current.opencodeModelUnsetTitle": "OpenCode 配置未指定模型",
  "api.current.opencodeModelUnsetDetail": "文件本身有效；OpenCode 可以继续使用最近的模型，或由你在模型列表中选择。",
  "api.current.unreadableTitle": "无法读取当前配置",
  "api.current.notConfigured": "未配置",
  "api.current.unreadable": "无法读取",
  "api.config.preview": "检查并应用",
  "api.config.previewTitle": ({ cli }) => `检查 ${cli} 配置`,
  "api.config.before": "当前文件",
  "api.config.after": "准备写入",
  "api.config.empty": "当前还没有这个配置文件。",
  "api.config.remoteRedacted": "远程客户端不会接收文件内容；应用前请在目标电脑上完成检查。",
  "api.config.apply": "应用配置",
  "api.warning.proxy_recommended": "代理模式由 Orni 统一管理凭据和故障切换",
  "api.warning.direct_mode_no_failover": "直接连接无法自动切换 Provider",
  "api.warning.direct_mode_writes_secret": "上游凭据将写入 CLI 配置文件",
  "api.warning.native_credential_chain": "这个 CLI 将使用系统 AWS 凭据链",
  "api.confirm.continue": "继续",
  "api.status.available": "可用",
  "api.status.degraded": "不稳定",
  "api.status.unavailable": "不可用",
  "api.status.unknown": "未测试",
  "api.monitor.title": "最近请求",
  "api.monitor.retention": "只保留最近 15 分钟的请求元数据，不记录请求正文和任何凭据。",
  "api.monitor.providerAll": "全部 Provider",
  "api.monitor.refresh": "刷新",
  "api.monitor.retrying": "重试中",
  "api.monitor.time": "时间",
  "api.monitor.client": "客户端 / User-Agent",
  "api.monitor.providerModel": "Provider / 模型",
  "api.monitor.request": "请求",
  "api.monitor.size": "大小",
  "api.monitor.status": "状态",
  "api.monitor.latency": "耗时",
  "api.monitor.unknownProvider": "未知 Provider",
  "api.monitor.empty": "最近没有请求",
  "api.monitor.emptyDetail": "经本地代理转发的请求会显示在这里。",
  "notes.title": "灵感与日记",
  "notes.new": "新建日记",
  "notes.inbox": "临时日记",
  "notes.untitled": "未命名日记",
  "notes.notebook": "日记",
  "notes.empty": "这里还没有内容，可以从上方开始记录。",
  "notes.emptyShort": "暂无内容",
  "notes.noSelection": "选择一本日记，或新建一本。",
  "notes.blockCount": ({ count }) => `${count} 个区块`,
  "notes.capturePlaceholder": "记录点什么…",
  "notes.quickCapture": "快捷记录",
  "notes.associateSession": "关联会话",
  "notes.associateSessionDetail": "选择这本日记的归属会话；关联后才能推送日记或区块。",
  "notes.createAndAssociate": "新建并关联会话",
  "notes.createAndAssociateDetail": "配置一个新会话，创建完成后自动关联这本日记。",
  "notes.existingSessions": "已有会话",
  "notes.noSessionsAvailable": "暂时没有可关联的会话。",
  "notes.removeAssociation": "解除关联",
  "notes.openSession": "进入会话",
  "notes.sendNotebook": "推送日记",
  "notes.sendBlock": "推送区块到会话",
  "notes.confirmOpenTitle": "进入这个会话？",
  "notes.confirmOpenDetail": "确认后将离开灵感与日记，进入已关联的会话。",
  "notes.confirmSendNoteTitle": "推送这些日记？",
  "notes.confirmSendBlockTitle": "推送这些区块？",
  "notes.confirmSendDetail": "请确认要推送的内容；它们将发送到已关联的会话。",
  "notes.destinationSession": "目标会话",
  "notes.selectNotebooks": "要推送的日记",
  "notes.selectBlocks": "要推送的区块",
  "notes.currentSelection": "当前选择 · 必选",
  "notes.included": "已选择",
  "notes.notIncluded": "未选择",
  "notes.confirmOpen": "进入会话",
  "notes.confirmSend": "推送并进入",
  "notes.linkBeforeSending": "请先关联会话",
  "notes.associationFailed": "无法更新会话关联。",
  "notes.sendFailed": "无法将内容推送到关联会话。",
  "notes.noSession": "不关联会话",
  "notes.noProject": "未关联项目",
  "notes.insertIntoSession": "放入会话输入框",
  "notes.move": "移动区块",
  "notes.copy": "复制区块",
  "notes.copied": "已复制",
  "notes.reorder": "调整区块顺序",
  "notes.deleteBlock": "删除区块",
  "notes.deleteBlockConfirm": "删除这个区块？",
  "notes.merge": "合并区块",
  "notes.mergeNotebook": "合并日记",
  "notes.mergedFrom": ({ source }) => `合并自 ${source}`,
  "notes.targetBlock": "合并到区块",
  "notes.noMergeTarget": "这本日记中没有其他可合并的区块。",
  "notes.confirmAction": "确认",
  "notes.action.move": "移动区块",
  "notes.action.merge": "合并区块",
  "notes.action.merge_note": "合并日记",
  "notes.action.chooseTarget": "在这里选好目标，一次完成。",
  "notes.deleteTitle": "删除这本日记？",
  "notes.deleteDetail": "日记中的所有区块都会被永久删除。",
  "notes.loadFailed": "无法加载 Note。",
  "notes.saveFailed": "Note 保存失败。",
  "notes.actionFailed": "Note 操作失败。",
  "notes.cloudRequired": "请登录 Orni Cloud 后查看或保存 Note。未保存的草稿会保留在本机。",
} satisfies Record<TranslationKey, TranslationValue>;
